import React, { useState } from 'react';
import './CheckboxCustom.css';

const CheckboxCustom = ({ 
  checked: controlledChecked,
  onChange,
  label,
  disabled = false,
  size = 'medium',
  color = '#2196f3',
  className = '',
  id,
  name,
  value,
  indeterminate = false
}) => {
  const [uncontrolledChecked, setUncontrolledChecked] = useState(false);
  
  // Используем управляемый или неуправляемый компонент
  const isControlled = controlledChecked !== undefined;
  const checked = isControlled ? controlledChecked : uncontrolledChecked;
  
  const handleChange = (e) => {
    if (disabled) return;
    
    if (!isControlled) {
      setUncontrolledChecked(!checked);
    }
    
    if (onChange) {
      onChange(e);
    }
  };
  
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleChange(e);
    }
  };
  
  const checkboxId = id || `checkbox-${Math.random().toString(36).substr(2, 9)}`;
  
  return (
    <div className={`checkbox-container ${className} ${disabled ? 'disabled' : ''}`}>
      <div className="checkbox-wrapper">
        <input
          type="checkbox"
          id={checkboxId}
          checked={checked}
          onChange={handleChange}
          disabled={disabled}
          className="checkbox-input"
          name={name}
          value={value}
          aria-checked={checked}
          data-indeterminate={indeterminate && !checked}
        />
        <label 
          htmlFor={checkboxId} 
          className={`checkbox-custom ${size} ${indeterminate && !checked ? 'indeterminate' : ''}`}
          style={{ '--checkbox-color': color }}
          tabIndex={disabled ? -1 : 0}
          onKeyDown={handleKeyDown}
          aria-disabled={disabled}
        >
          <span className="checkbox-checkmark">
            <svg viewBox="0 0 12 10" className="checkbox-svg">
              <polyline points="1.5 6 4.5 9 10.5 1" />
            </svg>
          </span>
        </label>
        
        {label && (
          <label 
            htmlFor={checkboxId} 
            className={`checkbox-label ${disabled ? 'disabled' : ''}`}
          >
            {label}
          </label>
        )}
      </div>
    </div>
  );
};

export default CheckboxCustom;

